module.exports = __webpack_public_path__ + "static/media/calendar.426dec02.svg";